import React, { useRef } from "react";
import { Star, EyeOff, Settings2, X } from "lucide-react";

/** Lang indrukken (telefoon) of rechtermuisklik (pc) op een menu-item → snelmenu. Navigatie wordt onderdrukt na een lange druk. */
export function useLangDruk(onLangDruk, ms = 550) {
  const timer = useRef(null);
  const gevuurd = useRef(false);
  const stop = () => { if (timer.current) { clearTimeout(timer.current); timer.current = null; } };
  return {
    onPointerDown: (e) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      gevuurd.current = false;
      stop();
      timer.current = setTimeout(() => { gevuurd.current = true; onLangDruk(e); }, ms);
    },
    onPointerUp: stop, onPointerLeave: stop, onPointerCancel: stop, onPointerMove: (e) => { if (e.pointerType === "touch") stop(); },
    onContextMenu: (e) => { e.preventDefault(); gevuurd.current = true; onLangDruk(e); },
    onClick: (e) => { if (gevuurd.current) { e.preventDefault(); e.stopPropagation(); gevuurd.current = false; } },
  };
}

export function MenuSnelActie({ item, isFavoriet, onFavoriet, onVerberg, onInstellingen, onClose }) {
  if (!item) return null;
  const Icon = item.icon;
  return (
    <div className="fixed inset-0 z-[70]" data-testid="menu-snelactie" onClick={onClose}>
      <div className="absolute inset-0 bg-black/30" />
      <div className="absolute inset-x-0 bottom-0 sm:inset-auto sm:left-1/2 sm:top-1/2 sm:-translate-x-1/2 sm:-translate-y-1/2 sm:w-80 bg-white rounded-t-2xl sm:rounded-xl shadow-xl p-3 safe-bottom animate-in slide-in-from-bottom-4 sm:zoom-in-95" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 px-1 pb-2 border-b border-slate-100">
          {Icon && <Icon className="h-4 w-4 text-slate-500" />}
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold truncate" data-testid="menu-snelactie-titel">{item.label}</div>
            {item.cat && <div className="text-[11px] text-slate-500 truncate">{item.cat}{item.subgroup ? ` › ${item.subgroup}` : ""}</div>}
          </div>
          <button onClick={onClose} className="p-1.5 text-slate-400 hover:text-slate-800" aria-label="Sluiten" data-testid="menu-snelactie-sluiten"><X className="h-4 w-4" /></button>
        </div>
        <div className="pt-2 space-y-1">
          <button onClick={onFavoriet} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm hover:bg-amber-50 text-slate-800" data-testid="menu-snelactie-favoriet">
            <Star className="h-4 w-4 text-amber-500" fill={isFavoriet ? "currentColor" : "none"} /> {isFavoriet ? "Uit favorieten halen" : "Favoriet — bovenaan in het menu"}
          </button>
          <button onClick={onVerberg} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm hover:bg-rose-50 text-slate-800" data-testid="menu-snelactie-verberg">
            <EyeOff className="h-4 w-4 text-rose-500" /> Verbergen uit het menu
          </button>
          <button onClick={onInstellingen} className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm hover:bg-slate-100 text-slate-600" data-testid="menu-snelactie-instellingen">
            <Settings2 className="h-4 w-4" /> Menu aanpassen…
          </button>
        </div>
      </div>
    </div>
  );
}

export default MenuSnelActie;
